import { SimpleEndodonticTableData, SimpleEndodonticTableRow } from './types'

export const SIMPLE_ENDODONTIC_TABLE_COLUMNS = [
  { key: 'tooth', label: 'Tooth #' },
  { key: 'percussion', label: 'Percussion' },
  { key: 'palpation', label: 'Palpation' },
  { key: 'cold', label: 'Cold' },
  { key: 'ept', label: 'EPT' },
] as const

export const MIN_SIMPLE_ENDODONTIC_ROWS = 1
export const MAX_SIMPLE_ENDODONTIC_ROWS = 10

export const createEmptySimpleEndodonticTableRow = (): SimpleEndodonticTableRow => ({
  tooth: '',
  percussion: '',
  palpation: '',
  cold: '',
  ept: '',
})

export const createEmptySimpleEndodonticTable = (): SimpleEndodonticTableData => ({
  rows: [createEmptySimpleEndodonticTableRow()],
})

export const isSimpleEndodonticTable = (value: unknown): value is SimpleEndodonticTableData =>
  typeof value === 'object' && value !== null && Array.isArray((value as SimpleEndodonticTableData).rows)

const normalizeRow = (row: Partial<SimpleEndodonticTableRow> | null | undefined): SimpleEndodonticTableRow => ({
  tooth: row?.tooth ?? '',
  percussion: row?.percussion ?? '',
  palpation: row?.palpation ?? '',
  cold: row?.cold ?? '',
  ept: row?.ept ?? '',
})

export const parseSimpleEndodonticTable = (value: unknown): SimpleEndodonticTableData | null => {
  if (!value) {
    return null
  }

  try {
    const parsed = typeof value === 'string' ? JSON.parse(value) : value

    if (!isSimpleEndodonticTable(parsed)) {
      return null
    }

    const rows = parsed.rows
      .filter((row) => row && typeof row === 'object')
      .slice(0, MAX_SIMPLE_ENDODONTIC_ROWS)
      .map(normalizeRow)

    return {
      rows: rows.length ? rows : [createEmptySimpleEndodonticTableRow()],
    }
  } catch {
    return null
  }
}

export const stringifySimpleEndodonticTable = (table: SimpleEndodonticTableData) => JSON.stringify(table)
